/*
 * @Author       : lilb-b
 * @Date         : 2022-09-21 15:04:02
 * @LastEditTime: 2022-09-29 14:15:18
 * @LastEditors: GRANDSOFT\hej-n
 * @Description  :
 * @FilePath: \fe_spa_joint_procurement\src\api\home.js
 */

import request from "@/utils/request-test";
// import http from "@/utils/http";
import { webUrl } from "./config";

const baseUrl = webUrl.baseUrl;
const ugwUrl = webUrl.ugwUrl;

//根据类型查询联采内容列表
export function getListByType(params, cb) {
  return request({
    url: `${baseUrl}/m2/content/getListByType`,
    params,
    cb,
  });
}

//根据id查询联采内容详情
export function ligetDetailByIdst(params, cb) {
  return request({
    url: `${baseUrl}/m2/content/getDetailById`,
    params,
    cb,
  });
}

//用户信息
export function info(cb) {
  return request({
    url: `${ugwUrl}/member/portal/session/user-info`,
    cb,
    codes: [200, 401],
  });
}
